export default {
  props: {
    containerColor: {
      type: String,
      default: 'blue',
    },
    clipPathId: {
      type: String,
      required: true,
    },
  },
  computed: {
    contrastingColor() {
      //
      // Original -> import variables from '../../../aiq-theme/aiq-variables.scss';
      //             #28292c is variables.darkerColor
      // In vue3, this variable is working on the aiq demo page.
      // But this variable is not working on the other pages (web-chat, dashboard)
      // I don't know how to fix it and there is only one scss import.
      // So I hard-coded it.
      return this.containerColor === 'blue' ? '#28292c' : 'white';
    },
    clipPathUrl() {
      return `url(#${this.clipPathId})`;
    },
  },
};
